import { isLocal } from './IsLocal';
import { isProd } from './IsProd';

export const DEFAULT_REVALIDATE = isProd ? 3600 : isLocal ? 30 : 30; // 60 minutes in prod, 30 second in dev, 30 second in local
